import type { DeliveryAddress } from '~/models/DeliveryAddress.model';
import FetchFactory from '../factory';
import { type FetchOptions } from 'ofetch';

class DeliveryAddressModule extends FetchFactory<DeliveryAddress> {
  /**
   * Return a delivery address
   * @param asyncDataOptions options for `useAsyncData`
   * @returns
   */
  async getDeliveryAddress() {
    const url = `/api-electra/Address/GetDeliveryAddress`;
    const fetchOptions: FetchOptions<'json'> = {
      headers: {
        'Accept-Language': 'en-US',
      },
    };
    return await this.call('GET', url, undefined);
  }
}

export default DeliveryAddressModule;
